<template>
    <div id="app" ref="app" class="app">
        <div class="app-content">
            <!-- <MyHeader/> -->
            <router-view :class="isPc?'model-pc':'model-mobile'" />
        </div>
        
        <LoadingBox ref="LoadingBox"></LoadingBox>
        <ConfirmBox ref="ConfirmBox"></ConfirmBox>
        <ConnectWalletBox ref="ConnectWalletBox"></ConnectWalletBox>
        <MessageDialog ref="MessageDialog"></MessageDialog>
        <!-- <PayPwdBox ref="PayPwdBox"></PayPwdBox> -->
        <BindParentBox ref="BindParentBox"></BindParentBox>
        <NoticeBox ref="NoticeBox"></NoticeBox>
    </div>
</template>

<script>
import bus from '@/assets/js/bus';
import { clearUserName,clearUserSign } from '@/assets/js/user';
import { getLanguage,setLanguage} from '@/assets/js/config';
import LoadingBox from '@/components/LoadingBox';
import ConfirmBox from '@/components/ConfirmBox';
import ConnectWalletBox from '@/components/ConnectWalletBox';
import MessageDialog from '@/components/MessageDialog';
import BindParentBox from '@/components/BindParentBox';
import NoticeBox from '@/components/NoticeBox';
// import PayPwdBox from '@/components/PayPwdBox';
// import MyHeader from '@/components/MyHeader'
export default {
    components:{
        ConnectWalletBox,LoadingBox,ConfirmBox,MessageDialog,BindParentBox,NoticeBox
    },
    data() {
		return {
            isPlay:false,
            isPc:false,
		};
	},
    created(){
        if(this.isMobile()){
            clearUserName();
            clearUserSign();
        }
        let _this = this;
        let lang = getLanguage();
        if(!lang || lang == 'undefined' || lang == undefined || lang == null){
            setLanguage("zh_cn");
            this.$i18n.locale = "zh_cn";
        }else{
            setLanguage(lang);
            this.$i18n.locale = lang;
        }

        bus.$on('showLoadingBox',async(msg) =>  {
            if(_this.$refs.LoadingBox){
                _this.$refs.LoadingBox.show();
            }
        });
        bus.$on('hideLoadingBox',async(msg) =>  {
            if(_this.$refs.LoadingBox){
                _this.$refs.LoadingBox.close();
            }
        });

        bus.$on('showConfirmBox',async(msg) =>  {
            _this.$refs.ConfirmBox.show(msg.type,msg.token1,msg.token2);
        });
        bus.$on('hideConfirmBox',async(msg) =>  {
            _this.$refs.ConfirmBox.close();
        });
        bus.$on('setConfirmBox',async(num) =>  {
            _this.$refs.ConfirmBox.setSetNum(num);
        });
        bus.$on('showPayPwdDialog',async() =>  {
            _this.$refs.PayPwdBox.show();
        });
        bus.$on('hidePayPwdDialog',async() =>  {
            _this.$refs.PayPwdBox.close();
        });
        bus.$on('showConnectWalletBox',async(msg) =>  {
            if(_this.$refs.ConnectWalletBox){
                _this.$refs.ConnectWalletBox.show(msg);
            }
        });
        bus.$on('hideConnectWalletBox',async(msg) =>  {
            if(_this.$refs.ConnectWalletBox){
                _this.$refs.ConnectWalletBox.close();
            }
        });
        bus.$on('showMessageDialog',async(msg) =>  {
            _this.$refs.MessageDialog.show(msg);
        });
        bus.$on('hideMessageDialog',async(msg) =>  {
            _this.$refs.MessageDialog.close();
        });
        bus.$on('showLanguageDialog',async(msg) =>  {
            _this.$refs.LanguageSetBox.show();
        });
        bus.$on('showBindParentBox',async() =>  {
            _this.$refs.BindParentBox.show();
        });
        bus.$on('hideBindParentBox',async() =>  {
            _this.$refs.BindParentBox.close();
        });
        bus.$on('showNoticeBox',async() =>  {
            _this.$refs.NoticeBox.show();
        });
        bus.$on('hideNoticeBox',async() =>  {
            _this.$refs.NoticeBox.close();
        });

        if (window.ethereum) {
            window.ethereum.on('chainChanged', (chainId) => {
                console.log("chainChanged:",chainId)
                clearUserName();
                clearUserSign();
                if(chainId == ("0x"+ this.chainId.toString(16))){
                    _this.connectWallet();
                }else{
                    bus.$emit('clearWalletAddress');
                }
            });
            window.ethereum.on('accountsChanged', (acountList) => {
                console.log("accountsChanged:",acountList)
                clearUserName();
                clearUserSign();
                if(acountList == null || acountList.length == 0){
                    bus.$emit('clearWalletAddress');
                }else{
                    _this.connectWallet();
                }
            });
        }
        bus.$on('connectWallet',async(msg) =>  {
            this.connectWallet();
        });
    },
    mounted(){
        if(this.isMobile()){
            console.log("isMobile:",true)
            this.isPc = false;
            import("@/assets/css/mobile.less");
        }else{
            console.log("isMobile:",false)
            this.isPc = true;
            import("@/assets/css/pc.less");
        }
    },
    methods:{
    }
}
</script>
<style lang="less">
@import "./assets/css/common.less";
@import "./assets/css/commonConfig.less";
#app{
    background:url('~@/assets/images/mpc/bg.png') center center no-repeat;
    background-size: 100% auto;
}
</style>
